<template lang="pug">

  app-page(title="Заявки на оплату" v-if="isAppLoaded")

      app-toolbar(:title="`Заявка на оплату по делу ${currentApp.courtCase.number}`")

      editAppItem(v-model="dialog.editAppItem" :appItem.sync="appItem"  @edited="dialog.editAppItem = false" @error="forbiddenError = true")

      v-snackbar(v-model="forbiddenError" color="red lighten-2" :timeout="6000" vertical bottom) Действия с заявкой запрещены
        v-btn(light text @click="forbiddenError = false") Закрыть

      v-layout(align-start)
        v-flex(xs7 sud-block-overlay)
          .sud-block-title Оказанные услуги по делу {{ currentApp.courtCase.shortNumber}}

              div.mt-4( v-if="currentApp.appType=='ADVOCAT' && currentApp.advocatAppItems!=null && currentApp.advocatAppItems.length > 0")
                advocatAppItemCard(
                  v-for="(l, index) in currentApp.advocatAppItems" 
                  :key="index" 
                  @click.native="selectItem(l)"
                  :advocatAppItem="l" :fromAdvocat="false"
                )
              div(v-else)
                v-card
                  v-card-title.text-center(plain style="padding-top: 50px;") Наименований нет


        v-flex(xs5 sud-block-overlay )
          .sud-block-title Заявка по делу {{ currentApp.courtCase.shortNumber}}
             advocatAppCardIn.mt-4(:advocatApp="currentApp" :fromAdvocat="false")
                v-layout.mt-3(align-center v-if="isNotReady && isJudge")
                   v-btn.text-none(
                     dark
                     color="#1B93AD" 
                     large depressed 
                     @click="confirmApp") Вынести постановление <!-- Согласовать всю заявку -->

                v-layout.mt-3(align-center v-if="isReady && !isSigned")
                   v-btn.text-none(
                     dark
                     color="#1B93AD" 
                     large depressed 
                     @click="showAppData") Подписать постановление

                v-layout.mt-3(align-center v-if="isReady && isSigned")
                   v-btn.text-none(
                     dark
                     color="#1B93AD" 
                     large depressed 
                     @click="openPrint") Распечатать постановление

                v-layout.mt-3(align-center v-if="isBuh")
                   v-btn.text-none(
                     dark
                     color="#1B93AD" 
                     large depressed 
                     @click="editBankAccount") Изменить реквизиты

      app-dialog(v-model="dialog.data" header="Проверить данные" confirm-text="Подтвердить" :confirm-disabled="isDataNotReady" @confirm="postData" width="500" )
         v-form(ref="appDataForm" v-model="valid")
           div(v-for="(d, index) in appData"  :key="index")
              app-text-field(v-if="showField.indexOf(index) != -1" v-model="appData[index]" :label="index" :rules="[rules.required]")
              app-text-field(v-if="showFreeField.indexOf(index) != -1" v-model="appData[index]" :label="index")


      bankAccount(v-model="dialog.editBankAccount" :bankAccount="bankAccount" @edit="afterEditBankAccount")

      signApp(v-model="dialog.sign" :appId="appId" @sendfail="showErrorSnack($event)" @ok="showSuccessSnack($event)")

      v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
        v-btn(light text @click="errorSnack = false") Закрыть
      v-snackbar(v-model="successSnack" color="success" :timeout="6000" vertical top) {{successSnackText}}
        v-btn(light text @click="successSnack = false") Закрыть

</template>

<script>
import editAppItem from './components/EditAppItem'
import addAdvocatAppItem from './advocat/components/AddAdvocatAppItem'
import advocatAppItemCard from './advocat/components/AdvocatAppItemCard'
import advocatAppCardIn from './advocat/components/AdvocatAppCardIn'
import { $_user_role as Role } from '@/common/UserUtils'
import bankAccount from './components/BankAccount'
import signApp from '../signature/components/SignApp'
import { specialistService } from '@/_services'
import { $_validate_rules } from '@/common/ValidateRules'

import { config } from '@/_helpers'

import { mapGetters } from 'vuex'

export default {
  mixins: [$_validate_rules],
  components: {
    editAppItem, 
    addAdvocatAppItem,
    advocatAppItemCard,
    advocatAppCardIn,
    bankAccount,
    signApp
  },
  props: {
    appId: null
  },

  created() {
    this.$store.dispatch('specialist/INIT_ITEM', { appId: this.appId })
  },

  methods: {
    confirmApp() {
      this.$store.dispatch('specialist/CONFIRM_APP', { appId: this.appId })
      .then(() => this.showAppData())
      .catch(() => this.forbiddenError=true)
    },

    openPrint() {
//      window.open(config.apiUrl+"specialist/internal/advocat/print/"+this.appId, '_blank')
//      window.open("ms-word:ofv|u|"+config.apiUrl+"specialist/internal/advocat/print/"+this.appId+"/advocatapp"+this.appId+".docx", '_blank')
      window.open(config.apiUrl+"specialist/internal/advocat/print/"+this.appId+"/advocatapp"+this.appId+".docx", '_blank')
    },

    selectItem (item) {
      if(this.isNotReady || (this.isJudge && !this.isSigned)){
        this.appItem = item
        this.dialog.editAppItem = true
      } else this.forbiddenError=true
    },

    fullName: (pers) => {
      return pers.persona.personaType.value==1?pers.persona.orgName:pers.persona.name
    },

    editBankAccount() {
      this.dialog.editBankAccount = true
    },

    afterEditBankAccount(ba) {
      this.currentApp.specialist.specialistGroup==null ? this.currentApp.specialist.bankAccount = ba : this.currentApp.specialist.specialistGroup.bankAccount = ba
    },

    showSignDocDialog() {
      this.dialog.sign = true
    },

    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },

    showSuccessSnack(text) {
      this.successSnackText = text
      this.successSnack = true
      this.currentApp.judgeSig="OK"
    },

    showAppData(){
      specialistService.getAdvocatAppData(this.appId).then( (data) =>{
         this.appData = JSON.parse(JSON.stringify(data))
         this.dialog.data = true
         this.$nextTick(() => {
           this.$refs.appDataForm.validate()
         })
      })
    }, 

    postData(){
      specialistService.postAdvocatAppData(this.appId, this.appData).then( () =>{
         this.dialog.data = false
         this.showSignDocDialog()
      })
    }, 


  },

  computed: {
    ...mapGetters('specialist', ['currentApp', 'isAppLoaded']),
    ...mapGetters('me', ['hasRole']),
    isJudge() {
      return this.hasRole([Role.judge, Role.judgeHelper, Role.limitjudge])
    },
    isBuh() {
      return this.hasRole([Role.accountant])
    },
    isNotReady () {
      return this.currentApp.appStatus.name === "SEND" || this.currentApp.appStatus.name === "REJECT" || this.currentApp.appStatus.name === "CHECK"
    },
    isReady () {
      return this.currentApp.appStatus.name === "CONFIRM" || this.currentApp.appStatus.name === "INREESTR"
    },

    isSigned () {
      return this.currentApp.judgeSig && this.currentApp.judgeSig!=''
    },

    bankAccount () {
      return this.currentApp.specialist.specialistGroup==null ? this.currentApp.specialist.bankAccount : this.currentApp.specialist.specialistGroup.bankAccount
    },
    isDataNotReady () {
      return !this.valid
    }, 

    showField () {
      return ["судья.фамилия",
        "судья.имя",
        "судья.отчество",
        "суд.название_кого",
        "суд.город",
        "суд.город_ком",
        "подзащитный.персона.имя_кого",
        "подзащитный.персона.дата_рождения",
        "дело.номер",
        "дело.номер_короткий",
        "дело.категория",
        "заявка.дата_ордера",
        "заявка.дата_заявки",
        "заявка.номер_ордера",
        "заявка.дней",
        "заявка.дней_прописью",
        "заявка.ночные",
        "заявка.выходные",
        "заявка.коэффициент",
        "заявка.даты",
        "заявка.сумма",
        "заявка.сумма_пропись",
        "адвокат.персона.имя",
        "адвокат.персона.имя_кого",
        "адвокат.персона.имя_кому",
        "адвокат.номер_удостоверения.",
        "BankAccount.bank",
        "BankAccount.bill",
        "BankAccount.inn",
        "BankAccount.bankBik",
        "BankAccount.bankBill"]
    }, 

    showFreeField () {
      return ["адвокат.коллегия."]
    }, 

  },

  data () {
    return {
      valid: false,
      errorSnackText: "Ошибка при подписании",
      successSnackText: "Подпись верна",
      errorSnack: false,
      successSnack: false,
      dialog: {
        editAppItem: false,
        editBankAccount: false,
        sign: false,
        data: false,
      },
      appItem: null,
      forbiddenError: false,
      appData: null,
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
